import { PurchaseOrderCountWidget } from '../base/PurchaseOrderCountWidget/PurchaseOrderCountWidget';

export const SampleCubeWidget = () => {
  return <PurchaseOrderCountWidget filters={[]} />;
};
